import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { NotificationManager } from "react-notifications";
import { ConsumidoresFinalesApi } from "../../api/ConsumidoresFinalesApi";
import { useDebouncedAsyncSelect } from "../../../../../Utils/Hooks/useDebounce";
import { getErrorFromResponse } from "../../../../../../../utility/utils";

export const useConsumidorFinalForm = (idConsumidorFinal, regresar) => {
    const {
        control: formControl,
        register: formRegister,
        setValue: formSetValue,
        getValues: formGetValues,
        trigger: validateForm,
        formState: { errors },
    } = useForm({
        mode: "onChange",
    });

    const [clientesAsociados, setClientesAsociados] = useState([]);
    const [clienteSeleccionado, setClienteSeleccionado] = useState(null);

    const {
        getClientes,
        getDetalleConsumidorFinal,
        crearConsumidorFinal,
        actualizarConsumidorFinal,
        agregarClienteConsumidorFinal,
        quitarClienteConsumidorFinal,
        cargando,
    } = ConsumidoresFinalesApi();

    const esEdicion = !!idConsumidorFinal;

    const loadClientes = useDebouncedAsyncSelect(function (search) {
        return getClientes({ search: search });
    });

    const GetDetalleConsumidorFinal = async () => {
        try {
            const data = await getDetalleConsumidorFinal(idConsumidorFinal);
            formSetValue("nombre", data.nombre);
            setClientesAsociados(data.clientes);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al cargar el consumidor final",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        if (idConsumidorFinal) {
            GetDetalleConsumidorFinal();
        }
    }, [idConsumidorFinal]);

    const AgregarCliente = async () => {
        if (!clienteSeleccionado) {
            NotificationManager.warning(
                "Debe seleccionar un cliente",
                "Atención",
                3000,
            );
            return;
        }

        const yaAsociado = clientesAsociados.some(
            (cliente) => cliente.id === clienteSeleccionado.id,
        );
        if (yaAsociado) {
            NotificationManager.warning(
                "El cliente ya está en la lista",
                "Atención",
                3000,
            );
            return;
        }

        // En la creación los clientes se guardan hasta que se guarda el formulario
        if (!esEdicion) {
            setClientesAsociados([...clientesAsociados, clienteSeleccionado]);
            setClienteSeleccionado(null);
            return;
        }

        try {
            const data = await agregarClienteConsumidorFinal(
                idConsumidorFinal,
                clienteSeleccionado.id,
            );
            setClientesAsociados(data.clientes);
            setClienteSeleccionado(null);
            NotificationManager.success(
                "Cliente agregado correctamente",
                "Éxito",
                3000,
            );
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al agregar el cliente",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const QuitarCliente = async (cliente) => {
        if (!esEdicion) {
            setClientesAsociados(
                clientesAsociados.filter((item) => item.id !== cliente.id),
            );
            return;
        }

        try {
            const data = await quitarClienteConsumidorFinal(
                idConsumidorFinal,
                cliente.id,
            );
            setClientesAsociados(data.clientes);
            NotificationManager.success(
                "Cliente quitado correctamente",
                "Éxito",
                3000,
            );
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al quitar el cliente",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const GuardarConsumidorFinal = async () => {
        const isValid = await validateForm();
        if (!isValid) return;

        const formValues = formGetValues();

        try {
            if (esEdicion) {
                await actualizarConsumidorFinal(idConsumidorFinal, {
                    nombre: formValues.nombre,
                });
                NotificationManager.success(
                    "Consumidor final actualizado correctamente",
                    "Éxito",
                    3000,
                );
            } else {
                await crearConsumidorFinal({
                    nombre: formValues.nombre,
                    clientes_ids: clientesAsociados.map(
                        (cliente) => cliente.id,
                    ),
                });
                NotificationManager.success(
                    "Consumidor final creado correctamente",
                    "Éxito",
                    3000,
                );
            }

            regresar();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al guardar el consumidor final",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    return {
        formControl,
        formRegister,
        errors,
        clientesAsociados,
        clienteSeleccionado,
        setClienteSeleccionado,
        loadClientes,
        esEdicion,
        cargando,
        AgregarCliente,
        QuitarCliente,
        GuardarConsumidorFinal,
    };
};
